var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDownload(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "30px",
    height: "30px",
    viewBox: "-6.409 -6.409 30 30",
    enableBackground: "new -6.409 -6.409 30 30",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon_awesome-download",
    fill: "#8A1538",
    d: "M6.73-3.325h3.723c0.613-0.005,1.113,0.489,1.116,1.103c0,0.004,0,0.009,0,0.013 v7.82h4.083c0.514,0.001,0.929,0.417,0.929,0.931c0,0.247-0.098,0.482-0.273,0.657l-7.073,7.084c-0.351,0.351-0.919,0.351-1.271,0 L0.868,7.199c-0.363-0.363-0.363-0.951,0-1.314C1.043,5.709,1.281,5.611,1.53,5.611h4.081v-7.82 C5.608-2.822,6.101-3.321,6.714-3.325C6.719-3.325,6.724-3.325,6.73-3.325z M20.508,14.178v5.213 c0.004,0.612-0.489,1.112-1.103,1.116c-0.005,0-0.01,0-0.014,0H-2.21c-0.612,0.004-1.112-0.49-1.116-1.103c0-0.004,0-0.01,0-0.014 v-5.213c-0.004-0.613,0.489-1.113,1.103-1.117c0.004,0,0.009,0,0.013,0h6.829l2.282,2.281c0.931,0.934,2.441,0.935,3.374,0.004 c0.002-0.002,0.003-0.003,0.005-0.004l2.28-2.281h6.829c0.612-0.005,1.113,0.487,1.119,1.1 C20.508,14.165,20.508,14.171,20.508,14.178z M14.735,18.273c0-0.513-0.416-0.93-0.931-0.93c-0.514,0-0.931,0.417-0.931,0.93 c0,0.516,0.417,0.933,0.931,0.933C14.318,19.202,14.734,18.786,14.735,18.273z M17.715,18.273c0-0.513-0.418-0.93-0.931-0.93 c-0.515,0-0.931,0.417-0.931,0.93c0,0.516,0.416,0.933,0.931,0.933C17.297,19.202,17.713,18.786,17.715,18.273z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownload);
export default __webpack_public_path__ + "static/media/download.3e3595c70563bb7bd7b84e0580edb54f.svg";
export { ForwardRef as ReactComponent };